import {
  useMutation,
  type MutationOptions,
  type UseMutationResult,
} from '@tanstack/react-query';
import type { ApiError } from '../../../../utils/api/ApiError/ApiError';
import { fetcher } from '../../../../utils/api/fetcher/fetcher';
import type { AutoEntitlement } from '../../../../utils/api/types/access-api-types';

export interface ProcessAutoEntitlementsBody {
  contextIds: string[];
  contextType: 'Class';
  subscriptionId: string;
  userId: string;
}

export type ProcessAutoEntitlementsResponse = Array<{
  error?: {
    code: string;
    message: string;
  };
  httpStatus?: number;
  payload?: AutoEntitlement;
}>;

export async function processAutoEntitlementsApi(
  autoEntitlementsBody: ProcessAutoEntitlementsBody
): Promise<ProcessAutoEntitlementsResponse> {
  return fetcher('/auto-entitlements/process-auto-entitlements', {
    method: 'POST',
    body: JSON.stringify(autoEntitlementsBody),
    service: '/fulfillment',
    version: '/v3',
  });
}

export function useProcessAutoEntitlementsApi(
  customMutationOptions?: MutationOptions<
    ProcessAutoEntitlementsResponse,
    ApiError,
    ProcessAutoEntitlementsBody
  >
): UseMutationResult<
  ProcessAutoEntitlementsResponse,
  ApiError,
  ProcessAutoEntitlementsBody
> {
  const { onSuccess, ...opts } = customMutationOptions ?? {};

  return useMutation({
    mutationFn: processAutoEntitlementsApi,
    onSuccess: (data, variables, context) => {
      onSuccess?.(data, variables, context);
    },
    ...opts,
  });
}
